import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import * as RouterActions from "../actions/router.action";

@Injectable()
export class RouterEffects {
  /**
     * Constructor
     *
     * @param {Actions} actions$
     * @param {Router} router
     * @param {Location} location
     */
  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location,
  ) {}

  /**
     * Navigate
     */
  navigate$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RouterActions.Go>(RouterActions.GO),
      tap((action: RouterActions.Go) => {
        const { path, query: queryParams, extras } = action.payload;
        this.router.navigate(path, { queryParams, ...extras });
      }),
    ),
  { dispatch: false },
  );

  /**
     * Navigate back
     * @type {Observable<any>}
     */
  navigateBack$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RouterActions.BACK),
      tap(() => this.location.back()),
    ),
  { dispatch: false },
  );

  /**
     * Navigate forward
     * @type {Observable<any>}
     */
  navigateForward$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RouterActions.FORWARD),
      tap(() => this.location.forward()),
    ),
  { dispatch: false },
  );
}
